import axios from 'axios'

import {getCookie} from '../helpers'
let token = getCookie('accessToken')

console.log('Request Debug url:',process.env.VUE_APP_API_URL)
export const api = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}/graphql`,
    headers: {
        'Authorization': token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
    },
    timeout: 30000
})

